import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { bootstrapTheme } from './theme/themeRuntime';
import './styles.css';

// Apply persisted theme BEFORE React mounts so the first paint already
// has the right brand palette + dark/light mode (no flash of unstyled brand).
bootstrapTheme();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found in index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
